import { useMemo, useCallback, useRef, useState } from "react"
import { useVenue } from "providers/venue"
import _ from "lodash"

export const useTouristPrivilege = () => {
  const { privileges } = useVenue()
  const ref = useRef<HTMLElement>()
  const [categoryFilter, setCategoryFilter] = useState("ALL")
  const categoryWithPrivilege = useMemo(
    () =>
      _(privileges)
        .uniqBy("properties.occupant.properties.local_parent_categories[0].id")
        .map(({ properties: { occupant } }) => {
          return occupant.properties.local_parent_categories[0]
        })
        .compact()
        .value(),
    [privileges]
  )

  const occupantWithPrivilege = useMemo(
    () =>
      privileges
        .map((privilege) => {
          const {
            properties: { occupant },
          } = privilege
          occupant.properties.privilege = privilege
          return occupant
        })
        ?.filter(
          (occupant) =>
            categoryFilter === "ALL" ||
            occupant.properties.local_parent_categories?.[0]?.id ===
              categoryFilter
        ),
    [categoryFilter, privileges]
  )

  const scrollToRef = useCallback(
    () => ref.current.scrollIntoView({ behavior: "smooth" }),
    [ref]
  )

  const handleChangeCategory = useCallback(
    (e, id) => {
      if (id === null) return
      setCategoryFilter(id)
      scrollToRef()
    },
    [scrollToRef]
  )

  return {
    categoryFilter,
    categoryWithPrivilege,
    occupantWithPrivilege,
    handleChangeCategory,
    ref,
  }
}
